/**
 * What the backend prepends to a payer created from the provider console.
 *
 * Documented on `ProviderCreatePayerPayload.name` ("The API prepends \"Generated Payer - \" to this
 * value before saving") and confirmed by @John Russell, 2026-09-11. The client never sends it; this
 * exists so the dialog can show the name that will be saved, and so demo mode saves the same name
 * the real API would.
 *
 * Dependency-free on purpose: the page imports it, and so does the demo generator, which must stay
 * out of the page's bundle and runnable in Node.
 */
export const GENERATED_PAYER_NAME_PREFIX = 'Generated Payer - ';

export function generatedPayerName(name: string): string {
    return `${GENERATED_PAYER_NAME_PREFIX}${name.trim()}`;
}
